import {
  Box,
  Chip,
  Divider,
  Typography
} from '@mui/material'

import { useEffect, useContext } from 'react'

// Context
import { InventoryDataContext, InventoryDispatchContext } from 'src/store/inventory/Store'
import { ItemDataContext } from 'src/store/items/Store'
import { setQuantity } from 'src/store/inventory/actions'
import { StatsDataContext } from 'src/store/stats/Store'

// Components
import ItemBlock from 'src/components/common/ItemBlock'
import Bag from 'src/components/common/Bag'
import CarryCapacity from 'src/components/common/CarryCapacity'
import { setSwitch } from 'src/store/navigation/actions'
import { NavigationDispatchContext } from 'src/store/navigation/Store'
import { hideScrollbarX, hideScrollbarY } from 'src/utils/cssStyles'

// style
const containerStyle = {
  zIndex: 4,
  position: 'absolute',
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  maxHeight: '100vh',
  top: '64px',
  padding: '24px',
  color: 'white',
  backgroundColor: 'black'
}

const stashStyle = {
  width: '100%',
  maxHeight: '128px',
  display: 'flex',
  flexDirection: 'row',
  ...hideScrollbarY,
  ...hideScrollbarX
}

const wrapper = {
  maxWidth: '324px',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '16px'
}

const Stash = () => {
  const { items } = useContext(ItemDataContext)
  const { stats } = useContext(StatsDataContext)
  const { inventory } = useContext(InventoryDataContext)
  const { dispatchInventory } = useContext(InventoryDispatchContext)
  const { dispatchNavigation } = useContext(NavigationDispatchContext)

  const handleLoot = (itemID: string) => {
    const bagItemCount = Object.entries(inventory.bag).reduce((total: number, [, prop]) => total + prop, 0)
    const isBagFull = inventory.stats.bag_slots <= bagItemCount
    const isOverWeight = stats.total.kg + items[itemID].weight >= stats.total.kg_max + stats.total.player_vit * 5

    if (!isBagFull && !isOverWeight) {
      setQuantity(dispatchInventory, 'bag', itemID, { '+': 1 })
      setQuantity(dispatchInventory, 'stash', itemID, { '-': 1 })
    }
  }

  const closeStashUI = () => setSwitch(dispatchNavigation, 'stash_open', false)

  const handleKeyDown = (e: KeyboardEvent) => {
    e.preventDefault()
    if (e.key === 'Escape') {
      closeStashUI()
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  // development build logs
  useEffect(() => {
    if (process.env.REACT_APP_BENCHMARK === 'true') { console.log('Stash mounted') }
    return process.env.REACT_APP_BENCHMARK === 'true' ? () => console.log('Stash unmounted') : () => { }
  }, [])

  useEffect(() => {
    if (process.env.REACT_APP_BENCHMARK === 'true') { console.log('Stash rendered') }
  })

  const filteredItemIDs = Object.keys(inventory.stash).filter(itemID => inventory.stash[itemID] > 0)

  return (
    <Box sx={containerStyle}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <Typography>Stash</Typography>
        <Chip label='x' sx={{ color: 'black', border: 'none', backgroundColor: 'white'}} onClick={closeStashUI}/>
      </Box>
      <Divider sx={{marginY: 2}}/>
      <Box sx={stashStyle} className='stash'>
        <Box sx={wrapper} className='items'>
          {filteredItemIDs.length ? (
            filteredItemIDs.map((inventoryItemID) => (
              new Array(inventory.stash[inventoryItemID]).fill('').map((_, index) => (
                <ItemBlock key={index} item={items[inventoryItemID]} handleClick={handleLoot} color={ (stats.equipped.kg + items[inventoryItemID].weight) > (stats.equipped.kg_max + stats.total.player_vit * 5) ? 'crimson' : 'white'}/>
              ))
            ))
          ) : (
            <ItemBlock handleClick={() => {}} />
          )}
        </Box>
      </Box>
      <Divider sx={{marginY: 2}}/>
      <Bag/>
      <Divider sx={{ marginY: 2 }} />
      <CarryCapacity />
    </Box>
  )
}

export default Stash
